@if (control) {
  <fieldset [attr.id]=" question.id ">
    <legend>
      <div [attr.aria-labelledby]=" question.id +'-err'"></div>
    </legend>
    @let title = text();
    @if (title) {
      <div id="{{ question.id }}-label-content" [innerHTML]="title"></div>
    }

    @if (controlHasError()) {
      <div class="alert  alert-danger error pill form-error-list">
        <div id="{{ question.id }}-err" class="error-list-wrapper" [attr.aria-live]="'assertive'">
          <ul>
            @for (err of baseForm.errorMap.get(question.id!); track err) {
              <li>
                <span>{{ determineErrorMessage(err.error!, this.control, question) }}</span>
              </li>
            }
          </ul>
        </div>
      </div>
    }
    <!-- make sure aria attributes and other are configurable -->
    <div [ngClass]="inputClass" class="container">
      <div id="charities-list" tabindex="0" [class.single-charity]="question.charityType === 'INITIATOR_ONLY'">
        @for (option of charityOptionsList; track $index) {
          <div class="row align-items-center ps-2 py-3">
            <label class="option " for="{{ question.id }}-{{ option.charityId }}">
              <input #input type="checkbox"
                     [attr.name]="question.id + '-' + option.charityId"
                     name="{{ question.id }}-{{ option.charityId }}"
                     id="{{ question.id }}-{{ option.charityId }}"
                     [value]="option.value"
                     [attr.aria-invalid]="controlHasError()"
                     [formControl]="formArray.controls[$index] | asFormControl"
                     (keydown.enter)="onEnter($event)"
                     (change)="toggleCharity(option);revalidateInput()"
                     [attr.aria-label]="getLabel()"/>
              <span class="checkmark"></span>

              <span class="complex-checkbox">
                <div class="col-5 img">
                  <img src="{{ option.logoUrl }}" class="option-logo" alt="{{ option.accountShortName }} logo"/>
                </div>
                <div class="col-7 option-content">
                  <div>
                    <h5 class="mb-2 mt-1">{{ option.accountShortName }}</h5>
                    <span>{{ option.charityMissionStatement }}</span>
                  </div>
                  <button class="pull-left btn more-info" data-toggle="collapse"
                          [attr.data-target]="'#'+ getInputId($index)"
                          (click)="option.collapsed = !option.collapsed"
                          [attr.aria-label]="'Show ' + (option.collapsed ? 'more' : 'less') + ' information about ' + option.accountShortName">
                    {{ option.collapsed ? 'More information' : 'Less information' }}
                    <i class="fa fa-1" [ngClass]="{'fa-angle-up': !option.collapsed, 'fa-angle-down': option.collapsed }"></i>
                  </button>
                </div>
              </span>

            </label>
            @if (!isHoriz() && $last && baseForm.isSubmitted(form) && control.touched) {
              <div #feedback
                   class="feedback-icon form-group radio" aria-hidden="true">
                <i class="fa" aria-hidden="true"
                   [ngClass]="{ 'fa-check-circle' : !controlHasError(), 'fa-times-circle' :  controlHasError() }"></i>
              </div>
            }
            <div class="collapse option-fullDescription" [class.show]="!option.collapsed" [id]="getInputId($index)">
              <span>{{ option.charityLongStatement }}</span>
            </div>
          </div>
        }
      </div>
      @if (findAddAnotherQuestion()) {
        <div id="add-another">
          <radio-button-control #addAnotherControl
                                [baseForm]="baseForm"
                                [form]="this.form"
                                [id]="addAnother!.id! + '-wrapper'"
                                [questionId]="addAnother!.id!"
                                [question]="addAnother!"
                                [standalone]="false"
                                [onEnter]="onEnter"></radio-button-control>
        </div>
      }
      <div class="option-row mx-0">
        <div class="pt-4 text-end">
          <button class="btn primary rounded-pill confirm-button"
                  [disabled]="baseForm.loading || baseForm.preventSave"
                  [attr.aria-label]="getLabel() + '.confirm_button'"
                  (click)="onEnter($event)"
                  (keydown.enter)="onEnter($event)">
            @if (baseForm.loading) {
              <span class="spinner-border spinner-border-sm mr-1"></span>
            }
            {{ messages.getText('WILL.button.save-and-continue') }}
          </button>
        </div>
      </div>
    </div>

  </fieldset>
}

<ng-content></ng-content>
